import { Pipe, PipeTransform } from '@angular/core';
import { currencyFormatter } from '@app/core/utils';

@Pipe({
    name: 'myNeeds'
})
export class MyNeedsPipe implements PipeTransform {
    transform(value: number, unit: string): string {
        if (value === null || unit === null) {
            return '';
        }

        switch (unit) {
            default:
            case '$':
                return `${currencyFormatter(value)}`;
            case '%':
                return `${(value * 100).toFixed(0)}%`;
            case 'year':
                if (value >= 0 && value <= 1) {
                    return `${value} year`;
                } else { return `${value} years`; }
            case 'age':
                if (value >= 0 && value <= 1) {
                    return `${value} year old`;
                } else { return `${value} years old`; }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/pipes/my-needs.pipe.ts